import { Controller } from "@hotwired/stimulus"

// Puts a document on the reference clipboard the documents sidebar reads (same key and entry shape), for pages
// without that sidebar: a published module's documents could not be copied at all (QA).
export default class extends Controller {
  static values = { level: String, id: Number, name: String, moduleId: Number, moduleTitle: String, copied: String, blocked: String }

  copy(event) {
    event.preventDefault()
    const key = "ds.references.copied"
    try {
      let clip = {}
      try { clip = JSON.parse(localStorage.getItem(key) || "{}") || {} } catch (_) { clip = {} }
      if (typeof clip !== "object" || Array.isArray(clip)) clip = {}
      clip[this.levelValue] = {
        id: this.idValue, name: this.nameValue, moduleId: this.moduleIdValue,
        moduleTitle: this.moduleTitleValue, copiedAt: Date.now()
      }
      localStorage.setItem(key, JSON.stringify(clip))
    } catch (_) {
      window.boToast?.(this.blockedValue, "alert")
      return
    }
    window.boToast?.(this.copiedValue.replace("%{name}", `“${this.nameValue}”`))
  }
}
